// extracted by mini-css-extract-plugin
export default {"-large":"F4gQu3AyHiBe05D8c8AH","divider":"CorsV3hZDdCPcTKDHYMI"};